import { render, staticRenderFns } from "./text-field-row-readonly-input.component.vue?vue&type=template&id=af248768&scoped=true&"
import script from "./text-field-row-readonly-input.component.vue?vue&type=script&lang=ts&"
export * from "./text-field-row-readonly-input.component.vue?vue&type=script&lang=ts&"
import style0 from "./text-field-row-readonly-input.component.vue?vue&type=style&index=0&id=af248768&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af248768",
  null
  
)

export default component.exports